
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import UserAccountsEditModal from './AccountsButton/UserAccountsEditModal';

@Component({
  components: {
    UserAccountsEditModal,
  },
})
export default class AccountsButton extends Vue {
  @Prop({ required: true })
  readonly userId!: string;

  openModal(): void {
    (this.$refs.editModal as UserAccountsEditModal).open(this.userId);
  }
}
